// extracted by mini-css-extract-plugin
export var carrierIcon = "_v3-0";
export var carrierLogo = "_v3-1";
export var detailsSection = "_v3-2";